var map = {
	"./ADA.svg": 784,
	"./BCH.svg": 785,
	"./BNB.svg": 786,
	"./BTC.svg": 787,
	"./CHZ.svg": 788,
	"./DASH.svg": 789,
	"./DOGE.svg": 790,
	"./DOT.svg": 791,
	"./ETC.svg": 792,
	"./ETH.svg": 793,
	"./EUR.svg": 794,
	"./GBP.svg": 795,
	"./LINK.svg": 796,
	"./LTC.svg": 797,
	"./MATIC.svg": 798,
	"./MKR.svg": 799,
	"./SHIB.svg": 800,
	"./SOL.svg": 801,
	"./TRX.svg": 802,
	"./UNI.svg": 803,
	"./USD.svg": 804,
	"./USDT.svg": 805,
	"./XLM.svg": 806,
	"./XMR.svg": 807,
	"./XRP.svg": 808,
	"./documents.svg": 809
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 783;